(() => {
  const drawer = document.querySelector('[data-menu-drawer]');
  const openBtn = document.querySelector('[data-menu-open]');
  const closeTargets = document.querySelectorAll('[data-menu-close]');

  if (!drawer || !openBtn) return;

  const setOpen = (open) => {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      const first = drawer.querySelector('a, button');
      if (first) first.focus();
    } else {
      openBtn.focus();
    }
  };

  openBtn.addEventListener('click', () => setOpen(true));
  closeTargets.forEach((el) => el.addEventListener('click', () => setOpen(false)));
  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });
})();
